import { EntityType } from "@frontend/common";
import { PlaylistItemClient } from "@frontend/playlist/api";
import { useResolver } from "@frontend/repository";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import React from "react";

declare global {
    interface WindowEventMap {
        'usePlaylistItem:request': CustomEvent<string>;
    }
}

const REQUEST_PLAYLIST_ITEM_EVENT = 'usePlaylistItem:request';
const STORAGE_KEY = 'PLYLST_ITEM_REQ';

export function playlistItemRequest(playlistItemId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_PLAYLIST_ITEM_EVENT, { detail: playlistItemId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function PlaylistItemResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_PLAYLIST_ITEM_EVENT, EntityType.PLAYLIST_ITEM, (ids) => PlaylistItemClient.resolvePlaylists(ids), props.dispatch);
    return <></>;
}
